import Teamcard from "../components/Teamcard";

export const Aboutus = () => (
    <div class="bg-white text-gray-800 font-sans">
        <section class="max-w-5xl mx-auto px-4 py-12">
            <h1 class="text-4xl font-bold text-center text-pink-600 mb-6">About Us</h1>
            
            <p class="text-lg mb-6 text-center max-w-3xl mx-auto">
            <strong>Welcome to Shinzura – Where Beauty Meets Confidence.</strong>
            </p>

            <p class="text-gray-700 leading-relaxed mb-4">
            At Shinzura, we’re more than just a beauty and fashion brand – we’re a movement that celebrates individuality, self-expression, and the power of feeling confident in your own skin. Born with a passion for quality and elegance, Shinzura curates a handpicked collection of beauty, skincare, and lifestyle essentials designed especially for the modern woman.
            </p>

            <p class="text-gray-700 leading-relaxed mb-4">
            Every product we offer is crafted to elevate your daily routine – from nourishing skincare that truly works, to trend-forward makeup and fashion pieces that turn heads. We believe in beauty that empowers, and our mission is to make you feel radiant, bold, and unapologetically you.
            </p>

            <p class="text-gray-700 leading-relaxed mb-4">
            Whether you're glowing up for a night out or embracing your natural vibe, Shinzura is here to be part of your journey. We stand for clean, effective, and luxurious products that suit Indian skin tones and lifestyles – because beauty should feel personal, not complicated.
            </p>

            <div class="mt-8">
            <h2 class="text-2xl font-semibold text-pink-500 mb-4">Why Choose Shinzura?</h2>
            <ul class="list-disc list-inside space-y-2 text-gray-700">
                <li><strong>💄 High-Quality Products:</strong> Carefully curated, tested, and loved.</li>
                <li><strong>✨ Made for You:</strong> Inclusive, cruelty-free, and designed for real results.</li>
                <li><strong>🌸 Empowering Beauty:</strong> More than makeup – it’s a mood, a mindset, a lifestyle.</li>
            </ul>
            </div>

            <p class="text-gray-700 leading-relaxed mt-6">
            Join our growing community of beauty lovers who are redefining glam with grace. Because with Shinzura, you don’t just wear beauty – you embody it.
            </p>
        </section>
        {/* Brand Vision / Mission */}
        <section className="bg-blue-50 py-10">
            <div className="max-w-4xl mx-auto px-4 text-center">
            <h2 className="text-3xl font-bold text-blue-600 mb-4">Our Vision</h2>
            <p className="text-gray-700 text-lg leading-relaxed">
                At Shinzura, our vision is to redefine beauty standards in India by offering
                premium, inclusive, and empowering lifestyle solutions. We aim to make luxury feel personal and accessible – one confident customer at a time.
            </p>
            </div>
        </section>

        {/* Team Section */}
        <Teamcard/>
    </div>
  );